import React, {Fragment} from 'react';
import Button from "../../../Button";
import TextInput from '../../../TextInput';
import Modal from "../../../../layout/Modal";
import Portal from "../../../../layout/Portal";
import {set, get} from '../../../../../utils/dotutils';
import {isEmpty} from "../../../../../utils/other";
import classNames from "classnames";
import Icon from "../../../Icon";
import { Tooltip } from 'react-tippy';
import {loadComponentById} from "../../../../../utils/components";
import {DeserializedElement, DeserializedElementRule} from "../../slate/Transformation";
import {Editor, Element as SlateElement, Range, Text, Transforms} from "slate";

class VariableNode extends React.Component<any, any> {

    state = {
        data: null
    }

    constructor(props) {
        super(props);
        this.loadData();
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.component_type + "_" + this.props.component_id + "_" + this.props.children[0].props.node.get('text') !== prevProps.component_type + "_" + prevProps.component_id + "_" + prevProps.children[0].props.node.get('text')) {
            this.loadData();
        }
    }

    loadData = () => {
        if (this.props.component_type && this.props.component_id) {
            this.loadDataRequest && this.loadDataRequest.abort();
            const field = this.props.children[0].props.node.get('text');
            this.loadDataRequest = loadComponentById(this.props.component_type, this.props.component_id, [field]);
            this.loadDataRequest.then((component) => {
                this.setState({data: get(component, field)});
            })
        } else {
            this.setState({data: null});
        }
    }

    render() {
        const Tag = this.state.data ? Tooltip : "span";
        return (
            <span
                {...this.props.attributes}
                className={classNames(this.props.attributes.className, this.props.node.data.get("type"), "variable")}
            >
                <span className="variable-text">{this.props.children}</span>
                {!!this.state.data && <Tag {...(this.state.data ? {html: this.state.data, tag: "span", position: "top"} : {})}>
                    <Icon lib="fas" name="info-circle"/>
                </Tag>}
                <span className="remove" onClick={(e) => {
                    e && e.preventDefault();
                    const change = this.props.editor.removeNodeByKey(this.props.node.key);
                    this.props.saveEditing && this.props.saveEditing(change);
                }}>
                    <Icon lib="fa" name="times"/>
                </span>
            </span>
        );
    }
}

export const VariableModal = (props) => {
    const {type, variable} = props.data;
    return <div className="row">
        <div className="col-md-12">
            {/*<div className="row form-row">
                <div className="col-md-12">
                    <Select name="type" objectValue={false} optionname="variabletype" storeType="local" saveChanges={props.setValue} value={type} label="Változó típusa" />
                </div>
            </div>*/}
            <div className="row form-row">
                <div className="col-md-12">
                    <TextInput name="variable" disabled={true} value={variable || ''} saveChanges={props.setValue} label="Változó" />
                </div>
            </div>
        </div>
    </div>;
};

const defaultEditData = {
    type: 'mustache', variable: ''
}

class VariableButton extends React.Component<any, {editing: boolean, value: any, selection?: any}> {

    state = {
        value: null,
        editing: false
    }

    openEditor = (e) => {
        e && e.preventDefault();
        let propsValue = null;
        if (this.props.isActive) {
            const [match] = Editor.nodes(this.props.editor, {
                match: n => n.type === 'variable'
            });
            propsValue = {...(match?.[0].props || {...defaultEditData})};
        } else {
            propsValue = {...defaultEditData, variable: this.props.editor.getFragment()?.[0]?.children?.[0]?.text || ''};
        }
        this.setState({editing: true, value: propsValue, selection: this.props.editor.selection});
        return false;
    }

    onModalChange = (field, value) => {
        const newValue = {...this.state.value};
        set(newValue, field, value);
        this.setState({value: newValue});
    }

    render() {
        const values = this.state.value || {};
        return <Fragment>
            <Button
                onClick={this.openEditor}
                icon="highlight_alt"
                color={this.props.isActive ? "primary" : "default"}
                tooltip={"Változó" + (!this.props.isActive ? " beszúrása" : " szerkesztése")}
                disabled={this.props.disabled || !this.props.isActive && (!this.props.selection || !Range.isExpanded(this.props.selection))}
            />
            <Portal>
                <Modal
                    state={this.state.editing ? "on" : "off"}
                    header={"Változó" + (!this.props.isActive ? " beszúrása" : " szerkesztése")}
                    buttons={[
                        {
                            text: "Ok",
                            props: {color: "primary", disabled: isEmpty(values.variable)},
                            onClick: async () => {
                                const data = {
                                    type: 'variable',
                                    props: {...this.state.value},
                                    children: this.props.editor.getFragment()?.[0]?.children || [{text: ''}]
                                };

                                Transforms.setSelection(this.props.editor, this.state.selection);
                                if (!this.props.isActive) {
                                    Transforms.insertNodes(
                                        this.props.editor,
                                        data,
                                        {
                                            match: n => Text.isText(n),
                                        }
                                    )
                                } else {
                                    Transforms.setNodes(this.props.editor, {
                                        ...data
                                    }, {
                                        match: n => n.type === 'variable'
                                    });
                                }

                                this.setState({editing:false});
                            }
                        }, {
                            text: "Mégse",
                            props: {color: "default"},
                            onClose: true,
                            onClick: async () => {
                                this.setState({editing:false});
                            }
                        }
                    ]}>
                    <VariableModal data={values} setValue={this.onModalChange} />
                </Modal>
            </Portal>
        </Fragment>
    }
}


export const Rules: {[key: string]: DeserializedElementRule<string>} = {
    "variable": {
        tagType: () => 'inline',
        isVoid: () => true,
        isActive: (editor) => {
            const [component] = Editor.nodes(editor, {
                match: n =>
                    !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === 'variable',
            })
            return !!component
        },
        match: (element) => element.type === 'variable',
        toolbarButton: VariableButton,
        deserialize(el, next) {
            if (el.slice(0,2) === '{{' && el.slice(-2) === '}}') {
                return {
                    type: 'variable',
                    props: {
                        type: 'mustache',
                        variable: el.slice(2, -2)
                    }
                };
            }
        },
        serialize(node, next) {
            if (node.type === 'variable') {
                if (node.props.type === 'mustache') {
                    return "{{" + node.props.variable + "}}";
                }
                // TODO else...
            }
        },
        render: ({editor, node}) => {
            if (node.element?.type === 'variable') {
                return <span {...node.attributes} className="variable">{node.children}{node.element.props.variable}</span>;
            }
        }
    },
};